import { useState, useCallback } from 'react';

const useFileUploadDragAndDrop = _ref => {
  let {
    disabled,
    onFilesSelected
  } = _ref;
  // Drag and drop logic
  const [showDropHover, setShowDropHover] = useState(false);
  const onDragOver = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
    if (!disabled && !showDropHover) {
      setShowDropHover(true);
    }
    if (disabled && showDropHover) {
      setShowDropHover(false);
    }
  }, [showDropHover, disabled]);
  const onDragEnter = useCallback(() => {
    if (!disabled && !showDropHover) {
      setShowDropHover(true);
    }
  }, [disabled, showDropHover]);
  const onDragLeave = useCallback(() => {
    if (showDropHover) {
      setShowDropHover(false);
    }
  }, [showDropHover]);
  const onDrop = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
    if (!disabled && e.dataTransfer.files.length) {
      onFilesSelected(e.dataTransfer.files);
    }
    setShowDropHover(false);
  }, [disabled, onFilesSelected]);
  return {
    showDropHover,
    onDragOver,
    onDragEnter,
    onDragLeave,
    onDrop
  };
};

export { useFileUploadDragAndDrop };
